var map = {
	"./BOU/serial.png": "84ba",
	"./DRU/serial.png": "c3c6",
	"./FNB/serial.png": "745e",
	"./HIM/serial.png": "e6d2",
	"./OTH/serial.png": "27aa",
	"./SUP/serial.png": "d4fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f179";